import { refreshAuth } from '@/api/authRefresh';
import axios from 'axios';

const API_PREFIX = process.env.NEXT_PUBLIC_API_PREFIX;

export const api = axios.create({
  baseURL: API_PREFIX,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // A 401 can mean the access token merely expired mid-session rather than
    // the user being logged out. Attempt one silent refresh + retry before
    // redirecting, so requests made during the refresh window don't bounce
    // an active session to the unauthorized page.
    if (error.response?.status === 401 && originalRequest && !originalRequest._retried) {
      originalRequest._retried = true;
      const refreshed = await refreshAuth();
      if (refreshed) {
        return api(originalRequest);
      }
    }

    if (error.response?.status === 401) {
      window.location.href = process.env.NEXT_PUBLIC_UNAUTHORIZED_REDIRECT_PATH;
    }
    return Promise.reject(error);
  },
);
